import React, { useState } from 'react';
import ToolbarIconButton from 'components/consumer/ToolbarIconButton';
import Link from 'components/consumer/Link';
import useUserData from 'data-hooks/useUserData';
import DropdownItem from './DropdownItem';

const HeaderToolbarDropdown = ({ icon, title = '', dropdownItems = [] }) => {
  const { isLoggedIn } = useUserData();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const onDropdownButtonClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div>
      <ToolbarIconButton
        data-xc="search"
        icon={icon}
        onClick={onDropdownButtonClick}
        title={title}
        className="max-[1023px]:hidden"
      />
      {isDropdownOpen && (
        <div className="absolute min-w-[8rem] top-12 bg-white border border-[#D9D9D9]">
          {dropdownItems &&
            dropdownItems.length &&
            dropdownItems.map((item, index) =>
              item?.link ? (
                <Link
                  to={
                    isLoggedIn && item?.loggedInLink
                      ? item?.loggedInLink
                      : item?.link
                  }
                  className="background:none] border-0 focus-visible:outline-offset-4 hover:text-brand hover:underline"
                >
                  <DropdownItem
                    isLoggedIn={isLoggedIn}
                    item={item}
                    index={index}
                  />
                </Link>
              ) : item?.onClick ? (
                <div onClick={item?.onClick} role="button" tabIndex={0}>
                  <DropdownItem item={item} index={index} />
                </div>
              ) : (
                <DropdownItem item={item} index={index} />
              )
            )}
        </div>
      )}
    </div>
  );
};

export default HeaderToolbarDropdown;
